import {
  collection,
  doc,
  type CollectionReference,
  type DocumentReference,
} from 'firebase/firestore';
import { firebaseDb } from '../firebase/init';

/**
 * Central Firestore path helpers. Everything a user owns lives under
 * users/{uid}/… (per-user isolation, enforced by firestore.rules). Keeping
 * the paths in one place means the rules, the repos, and the tests all agree.
 */

export const userDoc = (uid: string): DocumentReference =>
  doc(firebaseDb(), 'users', uid);

export const itemsCol = (uid: string): CollectionReference =>
  collection(firebaseDb(), 'users', uid, 'items');
export const itemDoc = (uid: string, itemId: string): DocumentReference =>
  doc(firebaseDb(), 'users', uid, 'items', itemId);

export const boxesCol = (uid: string): CollectionReference =>
  collection(firebaseDb(), 'users', uid, 'boxes');
export const boxDoc = (uid: string, boxId: string): DocumentReference =>
  doc(firebaseDb(), 'users', uid, 'boxes', boxId);

export const roomsCol = (uid: string): CollectionReference =>
  collection(firebaseDb(), 'users', uid, 'rooms');
export const roomDoc = (uid: string, roomId: string): DocumentReference =>
  doc(firebaseDb(), 'users', uid, 'rooms', roomId);

export const categoriesCol = (uid: string): CollectionReference =>
  collection(firebaseDb(), 'users', uid, 'categories');
export const categoryDoc = (uid: string, categoryId: string): DocumentReference =>
  doc(firebaseDb(), 'users', uid, 'categories', categoryId);

// --- Sharing (move collaborators) ---
export const collaboratorsCol = (ownerUid: string): CollectionReference =>
  collection(firebaseDb(), 'users', ownerUid, 'collaborators');
export const collaboratorDoc = (ownerUid: string, collabUid: string): DocumentReference =>
  doc(firebaseDb(), 'users', ownerUid, 'collaborators', collabUid);

export const sharedWithMeCol = (uid: string): CollectionReference =>
  collection(firebaseDb(), 'users', uid, 'sharedWithMe');
export const sharedWithMeDoc = (uid: string, ownerUid: string): DocumentReference =>
  doc(firebaseDb(), 'users', uid, 'sharedWithMe', ownerUid);

export const shareInvitesCol = (): CollectionReference =>
  collection(firebaseDb(), 'shareInvites');
export const shareInviteDoc = (ownerUid: string, emailLower: string): DocumentReference =>
  doc(firebaseDb(), 'shareInvites', `${ownerUid}__${emailLower}`);
